import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import app_setting_plus_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_plus_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import internet from '@devices/settings/device_settings/internet';

export default {
	name: 'shellyrgbw2',
	friendly_name: 'RGBW 2',
	family: 'light',
	isPM: true,
	modes: {
		color: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			color_temp: false,
			color: true,
			slider: 'gain',
			gain: 0,
			has_white: 'white',
			effects: [
				{ label: 'OFF', id: 0 },
				{ label: 'METEOR SHOWER', id: 1 },
				{ label: 'GRADUAL CHANGE', id: 2 },
				{ label: 'FLASH', id: 3 },
			],
			settings: [
				timer,
				schedule,
				actions,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{
							title: 'advanced_developer_settings',
							component: 'advanced_developer_settings',
						},
						{ title: 'cloud', component: 'cloud' },
					],
				},
				app_setting_plus_rgbw_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'device_type', component: 'mode_rgb2' },
						{ title: 'button_type', component: 'button_type_rgbw2' },
						{ title: 'power_on_default', component: 'power_on_default_rr' },
						{ title: 'transition_time', component: 'transition_time' },
						{ title: 'dc_supply_voltage', component: 'dc_supply_voltage' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		white: {
			channels: 4,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			color: false,
			color_temp: false,
			slider: 'brightness',
			brightness: 0,
			effects: false,
			settings: [
				timer,
				schedule,
				{
					title: 'night_mode',
					components: [
						{
							title: 'night_mode',
							component: 'night_mode_rgbw',
							min_ver: '1.12.0',
						},
					],
				},
				actions,
				internet,
				app_setting_plus_rgbw_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'device_type', component: 'mode_rgb2' },
						{ title: 'button_type', component: 'button_type_rgbw2white' },
						{ title: 'power_on_default', component: 'power_on_default_rr' },
						{ title: 'transition_time', component: 'transition_time' },
						{ title: 'dc_supply_voltage', component: 'dc_supply_voltage' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
